import { render, staticRenderFns } from "./PapercleandDocumentiViewModalComponent.vue?vue&type=template&id=3a001634&scoped=true"
import script from "./PapercleandDocumentiViewModalComponent.vue?vue&type=script&lang=js"
export * from "./PapercleandDocumentiViewModalComponent.vue?vue&type=script&lang=js"
import style0 from "./PapercleandDocumentiViewModalComponent.vue?vue&type=style&index=0&id=3a001634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a001634",
  null
  
)

export default component.exports